import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const BASE = '/hanh-chinh/dat-phong-hop'

export function locDanhSachDatLichHop(querySt?: string | Record<string, unknown>) {
  try {
    const query = typeof querySt === 'string' ? queryString.parse(querySt) : (querySt || {})
    return axiosApi.get(`${BASE}/loc-danh-sach`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function layChiTietDatLichHop(meetingBookingId: number) {
  try {
    return axiosApi.get(`${BASE}/${meetingBookingId}/chi-tiet`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function layDanhSachDatPhongHopTheoPhong(meetingRoomId: number) {
  try {
    return axiosApi.get(`${BASE}/phong-hop/${meetingRoomId}/danh-sach`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function layDanhSachDatPhongHopTheoNguoiDung(userId: number) {
  try {
    return axiosApi.get(`${BASE}/nguoi-dung/${userId}/danh-sach`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function taoDatLichHop(params: any) {
  try {
    return axiosApi.post(`${BASE}/tao`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function capNhatDatLichHop(meetingBookingId: number, params: any) {
  try {
    return axiosApi.put(`${BASE}/${meetingBookingId}/cap-nhat`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function huyDatLichHop(meetingBookingId: number) {
  try {
    return axiosApi.put(`${BASE}/${meetingBookingId}/huy`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
